import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "💥", key: "createFast" },
  { emoji: "🎯", key: "accurateDetails" },
  { emoji: "🔧", key: "editWithoutStress" },
  { emoji: "🧰", key: "allInOnePlace" },
]

export default function CarsTopPriorityPage() {
  return (
    <RadioCardListPage translationKey="carsTopPriority" options={OPTIONS} />
  )
}
